import { useQuery } from '@apollo/client'
import { Checkbox, FormControlLabel } from '@mui/material'
import {
    CandidateFilterCategory,
    SearchIndexField,
} from '__generated__/graphql'
import { GetCompaniesById } from 'candidate/graphql/generatedProfile.gql'
import { useState } from 'react'
import { FilterWrapper } from 'recruiter/components/FilterWrapper'
import { filterCheckboxSx, filterCheckboxLabelSx } from 'recruiter/filterStyles'
import { useRosterSearchFilter } from 'recruiter/hooks'
import CompaniesAutocompleteMultiple from 'shared/components/CompaniesAutocomplete/CompaniesAutocompleteMultiple'
import { CompaniesAutocompleteProps } from 'shared/components/CompaniesAutocomplete/CompaniesAutocompleteProps'

export function RosterCompanyFilter() {
    const { value, setValue } = useRosterSearchFilter(
        SearchIndexField.RosterCompany
    )
    const [showOnlyTopTierCompanies, setShowOnlyTopTierCompanies] =
        useState(false)

    const companyIds = value?.value?.stringArray ?? []

    const { data, loading } = useQuery(GetCompaniesById, {
        variables: { ids: companyIds },
    })

    const handleCompanyChange: CompaniesAutocompleteProps<true>['onChange'] = (
        e,
        newCompanies
    ) => {
        if (newCompanies.length === 0) {
            setValue(null)
            return
        }

        setValue({
            category: CandidateFilterCategory.All,
            value: { stringArray: newCompanies.map(({ id }) => id) },
        })
    }

    return (
        <FilterWrapper
            label="Company"
            headerActions={
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={showOnlyTopTierCompanies}
                            size="small"
                            sx={filterCheckboxSx}
                        />
                    }
                    label="Top Tier"
                    onChange={() =>
                        setShowOnlyTopTierCompanies(!showOnlyTopTierCompanies)
                    }
                    sx={filterCheckboxLabelSx}
                />
            }
        >
            <CompaniesAutocompleteMultiple
                ChipProps={{ size: 'small' }}
                onChange={handleCompanyChange}
                getOptionLabel={({ value }) => value}
                placeholder="Search companies..."
                value={data?.companiesById || []}
                loading={loading}
                topTierOnly={showOnlyTopTierCompanies}
            />
        </FilterWrapper>
    )
}
